import React from "react"
import styled, {keyframes} from "styled-components"
import id from "@irati/utils/id"

type LoadingSpinnerSize = "sm" | "md" | "lg"

interface Props {
  id?: string
  size?: LoadingSpinnerSize
  inverted?: boolean
}

interface StyledProps {
  widthAndHeight: number
  inverted: boolean
}

const spinner = keyframes`
  100% {
    transform: rotate(1turn);
  }
`

const StyledSpinner = styled.div<StyledProps>`
  position: relative;
  display: inline-block;
  left: 50%;
  margin-left: -${({widthAndHeight}) => widthAndHeight / 2}px;
  width: ${({widthAndHeight}) => widthAndHeight}px;
  height: ${({widthAndHeight}) => widthAndHeight}px;
  border-radius: 50%;
  background: repeating-conic-gradient(#0000 1%, ${({theme, inverted}) => (inverted ? theme.colors.greys.white : theme.colors.primary1)});
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - ${({widthAndHeight}) => widthAndHeight / 10}px), #000 0px);
  animation: ${spinner} 1s infinite linear;
`

const Spinner = (props: Props) => {
  const {size, inverted} = props
  const widthAndHeight = size === "sm" ? 24 : size === "lg" ? 120 : 50
  return <StyledSpinner id={id("spinner", props)} widthAndHeight={widthAndHeight} inverted={!!inverted} />
}

export default Spinner
